import { useState, useEffect } from 'react';

export function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToForm = () => {
    document.getElementById('contact-form')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/77df666893d599ded7ec460fe7ee2c33.jpg')`
        }}
      />
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>

      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-gray-900/95 backdrop-blur-md shadow-lg' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center">
            <img 
              src="https://freewebsiteoffer.99-marketing.com/wp-content/uploads/2026/02/logo.png" 
              alt="Digital Age Marketing" 
              className="h-12"
            />
          </div>
          <div className="flex items-center gap-4">
            <button 
              onClick={scrollToForm}
              className="px-6 py-2.5 rounded-lg font-medium text-sm transition-all whitespace-nowrap cursor-pointer bg-teal-500 text-white hover:bg-teal-600"
            >
              Get Started
            </button>
            <a 
              href="tel:8004559670"
              className="px-6 py-2.5 rounded-lg font-medium text-sm transition-all whitespace-nowrap cursor-pointer border-2 border-white text-white hover:bg-white/10"
            >
              800-455-9670
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center text-white">
        <div className="inline-block mb-6 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/20">
          <p className="text-sm font-medium">Modern Website + SEO System</p>
        </div>
        
        <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
          Your Website Should Be<br />Your Best Salesperson
        </h1>
        
        <p className="text-xl md:text-2xl mb-8 text-gray-100 max-w-3xl mx-auto leading-relaxed">
          Get a modern website and SEO visibility system designed to attract customers from Google, AI search, voice assistants, and maps.
        </p>

        <div className="inline-block mb-8 px-6 py-3 bg-teal-500/90 backdrop-blur-sm rounded-lg">
          <p className="text-2xl font-bold">Starting at $399 per month</p>
        </div>

        <div className="grid md:grid-cols-3 gap-4 mb-10 max-w-3xl mx-auto">
          <div className="flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm rounded-lg px-4 py-3 border border-white/20">
            <i className="ri-check-line text-teal-400 text-xl"></i>
            <span className="text-sm font-medium">No upfront website cost</span>
          </div>
          <div className="flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm rounded-lg px-4 py-3 border border-white/20">
            <i className="ri-check-line text-teal-400 text-xl"></i>
            <span className="text-sm font-medium">Built to convert visitors</span>
          </div>
          <div className="flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm rounded-lg px-4 py-3 border border-white/20">
            <i className="ri-check-line text-teal-400 text-xl"></i>
            <span className="text-sm font-medium">Measurable visibility</span>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button 
            onClick={scrollToForm}
            className="px-8 py-4 bg-teal-500 text-white rounded-lg font-semibold text-lg hover:bg-teal-600 transition-all shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
          >
            See How Your Website Could Perform Better
          </button>
          <button 
            onClick={scrollToForm}
            className="px-8 py-4 bg-white text-gray-900 rounded-lg font-semibold text-lg hover:bg-gray-100 transition-all shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
          >
            Request Your Website + SEO Plan
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </div>
  );
}